import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import useNavigation from '../../../../hooks/useNavigation'
import {postDeleteAnnounce} from '../../../../apis/announce/deleteAnnouce'

interface IProps {
    className?: string
    id?: string
    deleteList?: string[]
}

const DeleteAnnounceModal = ({className, id, deleteList}: IProps, ref: any) => {
    const {goPostList} = useNavigation()
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        if (id) {
            await postDeleteAnnounce(id).then(() => {
                alert('Delete Post')
                goPostList()
            })
        }

        if (deleteList) {
            deleteList?.map(async list => {
                await postDeleteAnnounce(list)
            })
            alert('Delete Posts')
            window.location.reload()
        }
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Remove Post'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 포스트를 정말 삭제하시겠습니까? </Text>

                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Remove'} type={'red'} className={'flex-1'} onClick={() => onClickDelete()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeleteAnnounceModal)
